import React,{memo} from 'react'
import { Modal} from '@shopify/polaris'
import intl from "../../../../i18n/intl";
const NotSourcingCompleteModal = memo(({open, setPaymentData,paymentData}) => {
  return (
    <div>
      <Modal
        open={open}
        onClose={()=>setPaymentData((prevValue)=>({...prevValue,isNotSourcing:false}))}
        title={intl.get("Sourcing not completed")}
        primaryAction={{
          content: intl.get('Continue to pay'),
          onAction: ()=>setPaymentData((prevValue)=>({...prevValue,isNotSourcing:false,isShowBulkPaymentModal:true})),
        }}
        secondaryActions={[
          {
            content: intl.get('Cancel'),
            onAction: ()=>setPaymentData((prevValue)=>({...prevValue,isNotSourcing:false})),
          },
        ]}
      >
        <Modal.Section>
            <p>
            {`Some products haven’t completed sourcing yet. For the smoothest experience, we suggest waiting until all items are ready. You can also proceed now—your order will be split, and payment will only apply to the sourced items.`}
            </p>
        </Modal.Section>
      </Modal>
    </div>
  )
})

export default NotSourcingCompleteModal
